import { render, staticRenderFns } from "./ExpenseTypeForm.vue?vue&type=template&id=74ffb3a5"
import script from "./ExpenseTypeForm.vue?vue&type=script&lang=js"
export * from "./ExpenseTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ExpenseTypeForm.vue?vue&type=style&index=0&id=74ffb3a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports